import { BaseModel } from '@/api/base-model'
import { RealworksProductAPI } from '@/api/backend-client'
import { Company } from '@/api/model/company'

export class RealworksProduct extends BaseModel<RealworksProduct> {
    protected collectionName = RealworksProductAPI.collectionName

    constructor(
        public company: Company,
        public id: string,
        public realworksToken: string | null,
        public realworksId: number,
        public actief: boolean,
        public bedrijfscode: string | null,
        public btwCode: string | null,
        public grootboekCode: string | null,
        public inclusiefExclusief: string | null,
        public omschrijving: string | null,
        public prijs: number | null,
        public productCode: string | null,
        public tijdstipLaatsteWijziging: Date | null,
    ) {
        super(id)
    }

    static fromData(data: any) {
        return new RealworksProduct(
            data.company ? Company.fromData(data.company) : null,
            data.id,
            data.realworksToken,
            data.realworksId,
            data.actief,
            data.bedrijfscode,
            data.btwCode,
            data.grootboekCode,
            data.inclusiefExclusief,
            data.omschrijving,
            data.prijs,
            data.productCode,
            data.tijdstipLaatsteWijziging ? new Date(data.tijdstipLaatsteWijziging) : null,
        )
    }
}
